export default __webpack_public_path__ + "static/media/rotate-phone.e2655d03.png";